import { Category } from '@amzn/awsconcierge-magic-movie-machine-type-script-client';

export const avatarColors = [
  {
    fill: '#EE683E',
    peel: '#FAD3C7',
    color: 'red',
  },
  {
    fill: '#FFA500',
    peel: '#FFD68A',
    color: 'orange',
  },
  {
    fill: '#FFE600',
    peel: '#FFF38A',
    color: 'yellow',
  },
  {
    fill: '#6CEA80',
    peel: '#CAF7D1',
    color: 'green',
  },
  {
    fill: '#00B4E0',
    peel: '#52DCFF',
    color: 'blue',
  },
  {
    fill: '#847ED2',
    peel: '#D3D2EF',
    color: 'indigo',
  },
  {
    fill: '#D66BBD',
    peel: '#F2CFEA',
    color: 'violet',
  },
  {
    fill: '#A5B4B5',
    peel: '#DDE3E3',
    color: 'lightgrey',
  },
];

export const PopularMoviesCategory = {
  action: 'action',
  comedy: 'comedy',
  drama: 'drama',
  horror: 'horror',
  animation: 'animation',
  scifi: 'scifi',
  documentary: 'documentary',
  crime: 'crime',
  romance: 'romance',
};

export const movieGridView = {
  popularMovies: 'popularMovies',
  diagram: 'diagram',
  recommendedMovies: 'recommendedMovies',
};

export const movieGridTabs = [
  {
    name: 'Action',
    id: PopularMoviesCategory.action,
  },
  {
    name: 'Comedy',
    id: PopularMoviesCategory.comedy,
  },
  {
    name: 'Drama',
    id: PopularMoviesCategory.drama,
  },
  {
    name: 'Horror',
    id: PopularMoviesCategory.horror,
  },
  {
    name: 'Animation',
    id: PopularMoviesCategory.animation,
  },
  {
    name: 'Sci-Fi',
    id: PopularMoviesCategory.scifi,
  },
  {
    name: 'Crime',
    id: PopularMoviesCategory.crime,
  },
  {
    name: 'Romance',
    id: PopularMoviesCategory.romance,
  },
];

export const recommendedMovieGridTabs = [
  {
    name: 'Top Recommendations',
    id: Category.PERSONAL,
  },
  {
    name: 'Highly Rated',
    id: Category.HIGH_RATED,
  },
  {
    name: 'Hidden Gems',
    id: Category.HIDDEN_GEMS,
  },
  {
    name: 'Popular Movies',
    id: Category.POPULAR,
  },
];

/** AB Testing MetaData */
export const PROJECT_NAME = 'PersonalizeABTest';
export const FEATURE_ID = 'ShowFeature';
